import { ReactNode } from 'react';

/**
 * Contenedor visual reutilizable para secciones dentro de una página.
 *
 * Proporciona fondo blanco, borde y sombra.
 * Ideal para mostrar títulos, paneles, filtros o cualquier contenido
 * visual separado dentro del layout.
 */
interface PageTopBarProps {
  children: ReactNode;
}

const SectionWrapper = ({ children }: PageTopBarProps) => {
  return (
    <div className="mt-6 w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      {children}
    </div>
  );
};

export default SectionWrapper;
